import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="unsaved-changes"
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.dirty = false
    this.submitting = false
    this.intentToSubmit = false
    this.pendingNavigation = null

    this.markDirty = this.markDirty.bind(this)
    this.onClick = this.onClick.bind(this)
    this.onBeforeVisit = this.onBeforeVisit.bind(this)
    this.onSubmitStart = this.onSubmitStart.bind(this)
    this.onSubmitEnd = this.onSubmitEnd.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onBeforeUnload = this.onBeforeUnload.bind(this)

    this.element.addEventListener("input", this.markDirty)
    this.element.addEventListener("change", this.markDirty)
    this.element.addEventListener("trix-change", this.markDirty)
    this.element.addEventListener("submit", this.onFormSubmit, true)
    this.element.addEventListener("turbo:submit-start", this.onSubmitStart)
    this.element.addEventListener("turbo:submit-end", this.onSubmitEnd)

    document.addEventListener("click", this.onClick, true)
    document.addEventListener("turbo:before-visit", this.onBeforeVisit)
    window.addEventListener("beforeunload", this.onBeforeUnload)
  }

  disconnect() {
    this.element.removeEventListener("input", this.markDirty)
    this.element.removeEventListener("change", this.markDirty)
    this.element.removeEventListener("trix-change", this.markDirty)
    this.element.removeEventListener("submit", this.onFormSubmit, true)
    this.element.removeEventListener("turbo:submit-start", this.onSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.onSubmitEnd)
    document.removeEventListener("click", this.onClick, true)
    document.removeEventListener("turbo:before-visit", this.onBeforeVisit)
    window.removeEventListener("beforeunload", this.onBeforeUnload)
    document.body.classList.remove("overflow-hidden")
  }

  markDirty() {
    if (!this.submitting) this.dirty = true
  }

  onFormSubmit() {
    this.submitting = true
    this.intentToSubmit = false
    this.dirty = false
  }

  onSubmitStart() {
    this.submitting = true
  }

  onSubmitEnd(event) {
    this.submitting = false
    if (event.detail?.success) this.dirty = false
  }

  isSubmitTrigger(event) {
    const submit = event.target.closest("button[type='submit'], input[type='submit']")
    return submit && this.element.contains(submit)
  }

  onClick(event) {
    if (this.isSubmitTrigger(event)) {
      this.intentToSubmit = true
      setTimeout(() => { this.intentToSubmit = false }, 100)
      return
    }

    if (!this.dirty || this.submitting) return

    const link = event.target.closest("a[href]")
    if (!link) return

    const href = link.getAttribute("href")
    if (!href || href === "#") return
    if (link.dataset.turbo === "false") return

    event.preventDefault()
    event.stopImmediatePropagation()

    this.pendingNavigation = { type: "link", link }
    this.showDialog()
  }

  onBeforeVisit(event) {
    if (!this.dirty || this.submitting) return

    event.preventDefault()
    this.pendingNavigation = { type: "visit", url: event.detail.url }
    this.showDialog()
  }

  onBeforeUnload(event) {
    if (!this.dirty || this.submitting || this.intentToSubmit) return

    event.preventDefault()
    event.returnValue = ""
  }

  showDialog() {
    this.dialogTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  hideDialog() {
    this.dialogTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  stay() {
    this.pendingNavigation = null
    this.hideDialog()
  }

  leave() {
    this.dirty = false
    this.hideDialog()

    const pending = this.pendingNavigation
    this.pendingNavigation = null
    if (!pending) return

    if (pending.type === "link") {
      pending.link.click()
    } else {
      Turbo.visit(pending.url)
    }
  }
}
